module.exports = __webpack_public_path__ + "img/V17.36baf1bf.jpg";